import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { formatCurrency } from "@mostlycode/utils"

const StyledProductPrice = styled.span`
  display: flex;
  align-items: baseline;
  margin-top: auto;
  color: ${(props) => props.theme.colors.primary};
  font-weight: bold;
  font-size: 2.4rem;

  .prepend {
    font-weight: normal;
    margin-right: 0.5rem;
  }

  .append {
    font-weight: normal;
    margin-left: 0.5rem;
  }
`

function ProductPrice({
  text_before_price,
  text_after_price,
  regular_price,
  currency,
  children,
  ...props
}) {
  const regular_price_formatted = formatCurrency(
    regular_price / 100,
    currency,
    "da-dk",
    0
  )
  return (
    <StyledProductPrice {...props}>
      <span>
        <small className="prepend">{text_before_price}</small>
        {regular_price_formatted}
      </span>
      <small className="append">{text_after_price}</small>
    </StyledProductPrice>
  )
}

export default ProductPrice

ProductPrice.defaultProps = {}
ProductPrice.propTypes = {
  children: PropTypes.node,
}
